import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import * as kioskActions from './kiosk.actions';
import type { KioskState } from './kiosk.state';

export const kioskInitialState: KioskState = {
	settings: {
		findByName: true,
		findById: false,
		findByScan: false,
	},
	locationId: null,
	loaded: false,
};

const reducer = createReducer(
	kioskInitialState,
	on(kioskActions.loadKioskSettingsSuccess, (state, { settings }) => ({
		...state,
		settings,
		loaded: true,
	})),
	on(kioskActions.updateKioskSettingsSuccess, (state, { settings }) => ({
		...state,
		settings,
	})),
	on(kioskActions.setKioskLocationSuccess, (state, { locationId }) => ({
		...state,
		locationId,
	})),
	on(kioskActions.clearKioskLocationSuccess, (state) => ({
		...state,
		locationId: null,
	}))
);

export function kioskReducer(state: KioskState | undefined, action: Action) {
	return reducer(state, action);
}
